import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsAdminLoggedIn } from '../../store/reducers/adminAuthSlice';
import { verifyAdminToken } from '../../store/reducers/adminAuthSlice';

const AdminGuard = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsAdminLoggedIn);
  const { isInitialized } = useSelector((state) => state.adminAuth);

  useEffect(() => {
    if (!isInitialized) {
      // Verify admin token on mount
      dispatch(verifyAdminToken());
    }
  }, [dispatch, isInitialized]);

  useEffect(() => {
    if (isInitialized && !isLoggedIn) {
      navigate('/admin/login', { replace: true });
    }
  }, [isLoggedIn, isInitialized, navigate]);

  // Show loading while verifying token
  if (!isInitialized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        Loading...
      </div>
    );
  }

  return isLoggedIn ? children : null;
};

AdminGuard.propTypes = {
  children: PropTypes.node
};

export default AdminGuard;
